import styled from 'styled-components';

interface ButtonProps {
  bgcolor?: string;
  textcolor?: string;
  radius?: string;
}

const Button = styled.button<ButtonProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  outline: none !important;
  border: none;

  background-color: ${({ bgcolor }) => bgcolor ?? 'var(--color-deep-pink)'};

  color: ${({ textcolor }) => textcolor ?? 'var(--color-light-gray)'};

  border-radius: ${({ radius }) => radius ?? '20px'};

  font-weight: 400;
  font-size: 20px;
  padding: 4px 20px;
  line-height: 1.5;

  &:hover {
    outline: none;
  }

  &:active,
  &:focus,
  &:visited {
    outline: none;
    background-color: ${({ bgcolor }) => bgcolor ?? 'var(--color-deep-pink)'};
    filter: brightness(0.9);
  }

  &:disabled {
    border: none !important;
    outline: none !important;
    cursor: not-allowed;
    box-shadow: none;
    opacity: 0.65;
  }

  svg {
    width: 19px;
    height: 38px;
    margin-right: 6px;
  }
`;

export default Button;
